<template>
  <form class="form">
<!--    <div class="scene-toggle" v-if="canToggle && toggle">-->
<!--      <a-switch-->
<!--          :checked="status === 'edit'"-->
<!--          @update:checked="toggle()"-->
<!--          checked-children="编辑"-->
<!--          un-checked-children="详情"-->
<!--      />-->
<!--    </div>-->
    <div class="form-main">
      <widget-form-body :groups="groups"/>
    </div>
    <div class="form-btn-group" v-show="status === 'edit'">
      <sc-btn type="primary" :handler="() => emit('submit')" text="提交"/>
      <sc-btn
          style="margin-left: 10px"
          :disabled="!form.canReset.value"
          :handler="() => form.reset()"
          text="重置"
      />
    </div>
  </form>
</template>
<script setup lang="ts">
import {ScForm} from "@/models/ScForm";
import {FormContainerGroup} from "@/components/business/crud/widgets/FormWidgetContainer";
import WidgetFormBody from "@/components/business/crud/form/WidgetFormBody.vue";

const props = withDefaults(defineProps<{
  form: ScForm;
  canToggle?: boolean;
  toggle?: () => void;
  status?: "edit" | "show";
  groups: FormContainerGroup[]
}>(), {
  canToggle: true,
  status: "edit",
});

const emit = defineEmits<{
  (event: "submit"): void;
}>();


</script>
<style lang="scss" scoped>

.scene-toggle {
  padding: $spacing-small $spacing-extra-large;
}

.form {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-grow: 1;

  .form-main {
    flex-grow: 1;
    overflow: auto;
  }
  .form-btn-group {
    border-top: 1px solid $color-content-border;
    padding: $spacing-medium;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
